<template>
	<div>
		<h4 class="mb-0 px-3">{{ $t("account-page-facility-question.question-header") }}</h4>
		<div class="card-header py-3">
			{{ $t("account-page-facility-question.intro") }}<br />
			{{ $t("account-page-facility-question.intro2") }}<br />
			{{ $t("account-page-facility-question.intro3") }}
		</div>

		<!-- question's page navigation tabs -->

		<b-tabs
			nav-class="nav-tabs"
			content-class="mt-3"
			v-model="activeTab" 
		>
			<b-tab
				:title='$t("account-page-facility-question.first_tab_title")'
				:active="activeTab === 0"  
			>
				<MainQuestion v-if="activeTab === 0"/>
			</b-tab>

			<b-tab
				:title='$t("account-page-facility-question.second_tab_title")'
				:active="activeTab === 1"  
			>
				<OthersForm v-if="activeTab === 1"   />
			</b-tab>
		</b-tabs>

	</div>
</template>

<script>
	import MainQuestion from './question-tabs/main.vue';
	import OthersForm from './question-tabs/others.vue';

	export default {
		components: {
			MainQuestion,
			OthersForm
		},
		data () {
			return {
				activeTab: 0, 
			}
		}
	}

</script>

<style scoped>
	#dashboard_wrapper .card-header {
		border-bottom: none;
	}

	.card-header {
		border-bottom: none;
	}
</style>
